import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  createQuickLinkApi,
  deleteQuickLinkApi,
  getQuickLinkApi,
  sortQuickLinkApi,
} from '@apis/seller-center/quick-links.js';
import { Toast } from '@common-web';
import { getErrorString } from '@utils/utils';

const initialState = {
  quickLinks: [],
  pagination: null,
  success: false,
  loading: false,
};

export const fetchQuickLinks = createAsyncThunk('fetch/quick_links', async (linkType = '') => {
  try {
    const response = await getQuickLinkApi(`?f[link_type]=${linkType}`);
    return response;
  } catch (error) {
    Toast.error(getErrorString(error));
  }
});

export const saveQuickLinks = createAsyncThunk('save/quick_links', async (payload = {}) => {
  try {
    const response = await createQuickLinkApi(payload);
    return response;
  } catch (error) {
    Toast.error(getErrorString(error));
  }
});

export const sortQuickLinks = createAsyncThunk('sort/quick_links', async (payload = {}) => {
  try {
    const response = await sortQuickLinkApi(payload);
    return response;
  } catch (error) {
    Toast.error(getErrorString(error));
  }
});

export const deleteQuickLinks = createAsyncThunk('delete/quick_links', async (id = '') => {
  try {
    const response = await deleteQuickLinkApi(id);
    return response;
  } catch (error) {
    Toast.error(getErrorString(error));
  }
});

const QuickLinksSlice = createSlice({
  name: 'quick-links',
  initialState,
  reducers: {
    setQuickLinks: (state, action) => {
      if (action?.payload) {
        state.quickLinks = action.payload;
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchQuickLinks.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchQuickLinks.fulfilled, (state, action) => {
        state.quickLinks = action?.payload?.quick_links ?? [];
        state.pagination = action?.payload?.pagination;
        state.loading = false;
      })
      .addCase(saveQuickLinks.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveQuickLinks.fulfilled, (state, action) => {
        if (action?.payload?.quick_link) {
          state.quickLinks = [...state.quickLinks, action?.payload?.quick_link];
          state.loading = false;
        }
      })
      .addCase(deleteQuickLinks.fulfilled, (state, action) => {
        state.quickLinks = state.quickLinks.filter((link) => link.id !== action.meta.arg);
      });
  },
});

export const { setQuickLinks } = QuickLinksSlice.actions;
export default QuickLinksSlice.reducer;
